<template>
	<!--沙箱环境-->
	<div>
		<div class="sbox">
			<div class="content_wrap">
				<div class="warp clearfix bg">
					<strong class="sboxTitle">沙箱环境使用指南</strong>
					<div>
						<p class="firstagreetitle">1 、沙箱环境简介</p>
						<p class="textSj25 se-font">沙箱环境是银税通开放平台提供给独立软件开发商的测试环境。沙箱环境提供了测试账号与数据，沙箱环境的API权限不作限制，软件开发商可以在沙箱环境完成大部分API场景的测试工作，相比正式测试环境，沙箱环境可能会出现一些不稳定情况，如有碰到，请到支持中心反馈。</p>
						<p class="firstagreetitle">2 、接入流程</p>
						<!--<div class="se-access">沙箱环境接入</div>-->
						<div class="se-box clearfix">
							<span class="se-item">注册账号</span>
							<img src="../assets/images/jat.png">
							<span class="se-item">申请为开发者</span>
							<img src="../assets/images/jat.png">
							<span class="se-item">API开发</span>
							<img src="../assets/images/jat.png">
							<span class="se-item">接入沙箱环境测试</span>
						</div>
						<p class="firstagreetitle">3、 沙箱API</p>
						<p class="textSj25 se-font">沙箱API的定义与线上保持一致，不做权限和流量限制，沙箱提供了独立的API和授权地址：</p>
						<ul class="address-show">
							<li style="list-style-type: disc;">API服务地址：http://60.205.83.27/router/rest</li>
							<li style="list-style-type: disc;">授权服务地址：http://60.205.83.179/static/openplatform/index.html</li>
						</ul>
						<p class="textSj25 se-font" style="color: red;">注：沙箱环境拥有独立的AppKey和AppSecret，请不要使用线上的AppKey和AppSecret访问沙箱API。</p>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'sboxEverment',
		mounted(){
			this.check.checkSession(this);
		}
	}
</script>
<style lang="scss">
	.sbox {
		font-size: 14px;
	
		.bg {
			background: $white;
			padding-bottom: 30px;
		}
		.sboxTitle {
			line-height: 50px;
			color: $title;
			font-size: 18px;
			margin-left: 20px;
		}
		.firstagreetitle {
			font-size: 16px;
			margin: 20px;
			color: $link;
		}
		.textSj25 {
			text-indent: 25px
		}
		.se-font {
			padding: 0 20px;
			line-height: 30px;
		}
		.address-show li {
			line-height: 30px;
			list-style: none;
			margin-left: 60px;
		}
		.se-access {
			text-align: center;
			padding: 20px 0;
			font-size: 18px;
		}
		.se-box {
			text-align: center;
			line-height: 50px;
			img{
				position: relative;
				top:10px;
			}
		}
		.se-item {
			border-width: 0px;
			display: inline-block;
			width: 130px;
			height: 53px;
			background: inherit;
			background-color: rgba(255, 255, 255, 1);
			box-sizing: border-box;
			border-width: 1px;
			border-style: solid;
			-moz-box-shadow: none;
			-webkit-box-shadow: none;
			box-shadow: none;
			font-style: normal;
			color: $title;
			text-align: center;
			margin-right: 20px;
			line-height: 53px;
		}
		img {
			line-height: 50px;
		}
	}
	
	.left_meun_sup {
		display: inline-block;
		position: relative;
		width: 16px;
		height: 16px;
		line-height: 16px;
		color: $white;
		text-align: center;
		font-size: 12px;
		border-radius: 50%;
		top: -6px;
		background: $circle;
	}
</style>


// WEBPACK FOOTER //
// src/page/SboxEverment.vue